<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <!-- Title page  -->
                    <h1 class="page__title justify-content">
                        {{ $t(titlePage) }}
                    </h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        :title="$t('Create group')"
                        @click="
                            $router.push({
                                name: 'Create delivery campaign group',
                            })
                        "
                    >
                        {{ $t("Create group") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.groups.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <!-- Resumen agregado de todos los balanceadores -->
                <CRow class="p-2 m-0">
                    <CCol md="12">
                        <CCard class="position-relative mb-0">
                            <CCardHeader>
                                <strong>{{ $t("balancer_overview") }}</strong>
                            </CCardHeader>
                            <CCardBody>
                                <p
                                    v-if="overview.error"
                                    class="overview__empty mb-0"
                                >
                                    {{ $t("could_not_load_overview") }}
                                    <span v-if="overview.error !== true">
                                        ({{ overview.error }})
                                    </span>
                                </p>
                                <CRow v-else>
                                    <CCol
                                        v-for="kpi in overviewKpis"
                                        :key="kpi.key"
                                        :md="overviewColMd"
                                        sm="6"
                                        class="mb-2"
                                    >
                                        <BalancerKpi :kpi="kpi" />
                                    </CCol>
                                </CRow>
                            </CCardBody>
                            <CElementCover
                                :opacity="0.8"
                                class="bg-trasparent"
                                v-if="overview.loading"
                            />
                        </CCard>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.groups.allFields"
                                        :activeFields.sync="
                                            tables.groups.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.groups.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.groups.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.groups.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.groups.rows"
                                    :sorterValue.sync="
                                        tables.groups.sorterValue
                                    "
                                    @update:sorter-value="updateData()"
                                    v-bind="tables.groups"
                                    :resizable="false"
                                    size="sm"
                                >
                                    <template #name="{ item }">
                                        <div
                                            class="d-flex align-items-center"
                                        >
                                            <!--
                                                El estado sustituye a la columna
                                                `active`. El color no es el unico
                                                indicador: lleva tooltip y
                                                aria-label con el estado.
                                            -->
                                            <span
                                                class="groups__status"
                                                :class="
                                                    stringToBoolean(item.active)
                                                        ? 'groups__status--on'
                                                        : 'groups__status--off'
                                                "
                                                v-c-tooltip="
                                                    $t(
                                                        stringToBoolean(
                                                            item.active
                                                        )
                                                            ? 'active'
                                                            : 'stop'
                                                    )
                                                "
                                                :aria-label="
                                                    $t(
                                                        stringToBoolean(
                                                            item.active
                                                        )
                                                            ? 'active'
                                                            : 'stop'
                                                    )
                                                "
                                            ></span>
                                            <!--
                                                El tipo de balanceo sustituye a
                                                su columna: icono con el nombre
                                                del tipo en el tooltip.
                                            -->
                                            <CIcon
                                                :content="
                                                    $options.icons
                                                        .cilBalanceScale
                                                "
                                                class="groups__flag groups__flag--balancing"
                                                v-c-tooltip="
                                                    balancingLabel(item)
                                                "
                                            />
                                            <!--
                                                Flag: se pinta siempre y se
                                                oculta con `visibility` cuando
                                                no aplica, para que el hueco se
                                                mantenga y los nombres no bailen
                                                de fila a fila. Oculto asi no
                                                recibe puntero, asi que tampoco
                                                dispara el tooltip.
                                            -->
                                            <CIcon
                                                :content="
                                                    $options.icons
                                                        .cilListHighPriority
                                                "
                                                class="groups__flag groups__flag--priority"
                                                :class="
                                                    stringToBoolean(
                                                        item.return_priority_response
                                                    )
                                                        ? ''
                                                        : 'groups__flag--hidden'
                                                "
                                                :aria-hidden="
                                                    stringToBoolean(
                                                        item.return_priority_response
                                                    )
                                                        ? null
                                                        : 'true'
                                                "
                                                v-c-tooltip="
                                                    $t('return_priority')
                                                "
                                            />
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </template>
                                    <template #stats_attempts="{ item }">
                                        {{ statCount(item.stats_attempts) }}
                                    </template>
                                    <template #stats_leads_in="{ item }">
                                        {{ statCount(item.stats_leads_in) }}
                                    </template>
                                    <template #stats_ok="{ item }">
                                        {{ statCount(item.stats_ok) }}
                                    </template>
                                    <template #stats_delivered="{ item }">
                                        {{ statCount(item.stats_delivered) }}
                                    </template>
                                    <template #stats_not_delivered="{ item }">
                                        {{ statCount(item.stats_not_delivered) }}
                                    </template>
                                    <template #stats_delivery_rate="{ item }">
                                        {{ statRate(item.stats_delivery_rate) }}
                                    </template>
                                    <template #campaigns="{ item }">
                                        <CButton
                                            v-if="linkCount(item, 'campaigns') > 0"
                                            color="link"
                                            size="sm"
                                            class="p-0"
                                            :title="$t('inputs')"
                                            @click="
                                                openLinks(item, {
                                                    key: 'campaigns',
                                                    kind: 'inputs',
                                                })
                                            "
                                        >
                                            <CIcon
                                                :content="
                                                    $options.icons.cilList
                                                "
                                            />
                                            <span class="ml-1">
                                                {{ linkCount(item, 'campaigns') }}
                                            </span>
                                        </CButton>
                                        <span v-else class="text-muted">—</span>
                                    </template>
                                    <template #salidas="{ item }">
                                        <CButton
                                            v-if="linkCount(item, 'salidas') > 0"
                                            color="link"
                                            size="sm"
                                            class="p-0"
                                            :title="$t('outputs')"
                                            @click="
                                                openLinks(item, {
                                                    key: 'salidas',
                                                    kind: 'outputs',
                                                })
                                            "
                                        >
                                            <CIcon
                                                :content="
                                                    $options.icons.cilList
                                                "
                                            />
                                            <span class="ml-1">
                                                {{ linkCount(item, 'salidas') }}
                                            </span>
                                        </CButton>
                                        <span v-else class="text-muted">—</span>
                                    </template>
                                    <!--
                                        `active`, `shipment_balancing_type` y
                                        `return_priority_response` estan fuera
                                        de `fields` (van como punto e iconos
                                        delante del nombre), pero TableSettings
                                        puede reactivarlas: sin slot saldria el
                                        valor crudo.
                                    -->
                                    <template #active="{ item }">
                                        <CBadge
                                            v-if="stringToBoolean(item.active)"
                                            color="success"
                                        >
                                            {{ $t("active") }}
                                        </CBadge>
                                        <CBadge v-else color="secondary">
                                            {{ $t("stop") }}
                                        </CBadge>
                                    </template>
                                    <template
                                        #shipment_balancing_type="{ item }"
                                    >
                                        {{
                                            findBalancingShipmentTypeById(
                                                item.shipment_balancing_type
                                            )
                                        }}
                                    </template>
                                    <template #over-table>
                                        <CDropdown
                                            color="primary"
                                            :toggler-text="$t('actions')"
                                            class="m-2"
                                            :disabled="
                                                tables.groups.itemSelected ===
                                                null
                                            "
                                        >
                                            <CDropdownItem
                                                @click="
                                                    $router.push({
                                                        name: 'delivery_campaign_group_details',
                                                        params: {
                                                            uuid: tables.groups
                                                                .itemSelected
                                                                .uuid,
                                                        },
                                                    })
                                                "
                                            >
                                                {{ $t("Details") }}
                                            </CDropdownItem>
                                            <CDropdownItem
                                                @click="
                                                    $router.push({
                                                        name: 'delivery_campaign_group_logs',
                                                        params: {
                                                            uuid: tables.groups
                                                                .itemSelected
                                                                .uuid,
                                                        },
                                                    })
                                                "
                                            >
                                                {{ $t("Logs") }}
                                            </CDropdownItem>
                                            <CDropdownItem
                                                @click="
                                                    $router.push({
                                                        name: 'Update delivery campaign group',
                                                        params: {
                                                            uuid: tables.groups
                                                                .itemSelected
                                                                .uuid,
                                                        },
                                                    })
                                                "
                                            >
                                                {{ $t("Edit group") }}
                                            </CDropdownItem>
                                            <CDropdownItem
                                                @click="
                                                    archiveGroup(
                                                        tables.groups
                                                            .itemSelected
                                                    )
                                                "
                                            >
                                                {{ $t("Archive group") }}
                                            </CDropdownItem>
                                        </CDropdown>
                                    </template>
                                    <template #_selected="{ index, item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked.sync="
                                                tables.groups.items[index]
                                                    ._selected
                                            "
                                            @update:checked="
                                                selectItemTable('groups', item)
                                            "
                                        />
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/shipment.balancing.api/client-groups/pagination"
                                                :table="tables.groups"
                                                :adapterFilters="
                                                    adapterBalancerGroupsQuery
                                                "
                                                :queryParams="statsWindow"
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.groups.total_pages > 0">
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.groups.page"
                                        :pages="tables.groups.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.groups.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CModal
            :title="$t(modals.links.data.kind || 'inputs')"
            color="primary"
            size="sm"
            :show.sync="modals.links.show"
            :centered="true"
        >
            <ul
                v-if="(modals.links.data.items || []).length > 0"
                class="list-unstyled mb-0"
            >
                <li
                    v-for="entry in modals.links.data.items"
                    :key="entry.id"
                    class="mb-1"
                >
                    <!--
                        Las dos rutas de destino necesitan el uuid (la de
                        salidas lo lleva en el path). Sin uuid no hay enlace
                        posible, asi que se pinta el nombre sin enlazar en
                        lugar de una ruta rota.
                    -->
                    <RouterLink
                        v-if="entry.uuid"
                        :to="linkRoute(entry)"
                        >{{ entry.name }}</RouterLink
                    >
                    <span v-else>{{ entry.name }}</span>
                </li>
            </ul>
            <p v-else class="text-muted mb-0">{{ $t("no_linked_items") }}</p>
            <template #footer>
                <CButton
                    color="secondary"
                    @click="closeModal({ modalName: 'links' })"
                >
                    {{ $t("close") }}
                </CButton>
            </template>
        </CModal>
    </CCard>
</template>

<script>
/**
 * Components
 */
import CCTable from "~/components/CCTable";
import BalancerKpi from "./components/BalancerKpi.vue";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
import ButtonCreate from "~/components/ButtonCreate";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal.js";

/**
 * Others
 */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
    cilList,
    cilBalanceScale,
    cilListHighPriority,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import DeliveryCampaignGroupsTableConfig from "./config/tables/DeliveryCampaignGroups.js";
import { adapterBalancerGroupsQuery } from "~/utils/balancerGroupsQuery";
import { adapterBalancerGroupsStats } from "~/utils/balancerGroupsStats";

export default {
    name: "DeliveryCampaignGroupsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        ButtonExport,
        FilterFields,
        ButtonCreate,
        CCTable,
        BalancerKpi,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilList,
        cilBalanceScale,
        cilListHighPriority,
    },
    data() {
        return {
            tables: {
                groups: DeliveryCampaignGroupsTableConfig,
            },
            overview: {
                loading: false,
                data: {},
                error: null,
            },
            modals: {
                // Compartido por las columnas de entradas y salidas: cambian
                // el titulo, la lista y la ruta de destino de cada enlace.
                links: {
                    show: false,
                    data: {},
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            storeBalancingShipmentTypes: "global/balancingShipmentTypes",
        }),
        /**
         * Tarjetas del resumen agregado, en el orden del embudo.
         *
         * Solo llevan porcentaje `delivered` y `not_delivered`, que son los dos
         * que se reparten `leads_in`: su suma es el 100 %. `leads_in` es el
         * denominador, y `attempts`/`ok` son de otro nivel (envios, no leads),
         * asi que un % sobre leads seria enganoso — van atenuados.
         */
        overviewKpis: function () {
            const data = this.overview.data || {};
            const count = (key) => {
                const value = parseInt(data[key], 10);
                return isNaN(value) ? null : value;
            };
            // `delivery_rate` llega ya en 0..100 (`76.0`), no como fraccion: a
            // diferencia de los `*_rate` del detalle, aqui NO se multiplica.
            const uniquePending = count("unique_pending");
            const rate = parseFloat(data.delivery_rate);
            const deliveryRate = isNaN(rate) ? null : rate;
            const notDeliveredRate =
                deliveryRate === null ? null : 100 - deliveryRate;

            const kpi = (key, label, tone, percent, options = {}) => {
                const value = count(key);
                return {
                    key,
                    label,
                    tone,
                    muted: Boolean(options.muted),
                    hint: options.hint || null,
                    value: value === null ? "-" : value,
                    percentLabel:
                        percent === null ? "—" : `${percent.toFixed(1)}%`,
                    percentRounded: percent === null ? 0 : Math.round(percent),
                    // Redondeado: `26.489999999999995%` en el style inline
                    // no aporta nada y ensucia el DOM.
                    barWidth: `${
                        percent === null ? 0 : Math.round(percent * 100) / 100
                    }%`,
                };
            };

            return [
                kpi("attempts", "total_attempts", "neutral", null, {
                    muted: true,
                    hint: "attempts_count_hint",
                }),
                kpi("leads_in", "leads_in", "neutral", null, {
                    hint: "leads_in_hint",
                }),
                kpi("ok", "ok", "neutral", null, {
                    muted: true,
                    hint: "ok_sends_hint",
                }),
                kpi("delivered", "delivered", "success", deliveryRate),
                kpi(
                    "not_delivered",
                    "not_delivered",
                    "danger",
                    notDeliveredRate
                ),
                // Parados en `delivery_pending`, pendientes de reproceso
                // manual. No llevan % porque no son una fraccion de `leads_in`
                // ni de `attempts`: salen de otra tabla. En su lugar, la linea
                // de debajo lleva los leads distintos: `pending` cuenta envios,
                // asi que un lead parado en N salidas suma N.
                {
                    ...kpi("pending", "pending", "warning", null, {
                        hint: "pending_hint",
                    }),
                    percentLabel:
                        uniquePending === null
                            ? "—"
                            : `${uniquePending} ${this.$t("unique_leads")}`,
                },
                // El ratio que ya calcula el endpoint, como tarjeta propia: el
                // valor es el porcentaje, asi que la linea de % va vacia para
                // no repetirlo (se deja, no se quita, para que todas las
                // tarjetas midan igual de alto).
                {
                    key: "delivery_rate",
                    label: "delivery_rate",
                    tone: "success",
                    muted: false,
                    hint: null,
                    value:
                        deliveryRate === null
                            ? "-"
                            : `${deliveryRate.toFixed(1)}%`,
                    percentLabel: "",
                    percentRounded:
                        deliveryRate === null ? 0 : Math.round(deliveryRate),
                    barWidth: `${
                        deliveryRate === null
                            ? 0
                            : Math.round(deliveryRate * 100) / 100
                    }%`,
                },
            ];
        },
        /**
         * Seis tarjetas caben en una fila a `md="2"`; por encima se pasa a
         * cuatro por fila, porque 7 x 2 = 14 columnas de 12 y la septima se
         * quedaria sola en una segunda fila.
         */
        overviewColMd: function () {
            return this.overviewKpis.length > 6 ? "3" : "2";
        },
        /**
         * Ventana de los stats. La comparten la tabla y el export, para que el
         * CSV no salga con un rango distinto al que se ve en pantalla.
         */
        statsWindow: function () {
            return {
                stats_from: this.storeFrom,
                stats_to: this.storeTo,
            };
        },
    },
    watch: {
        storeBalancingShipmentTypes(newValue, oldValue) {
            let tableFieldBalancingShipmentTypes =
                this.tables.groups.fields.find((item) => {
                    return item.key == "shipment_balancing_type";
                });
            if (tableFieldBalancingShipmentTypes) {
                tableFieldBalancingShipmentTypes._filter.options = newValue.map(
                    (item) => {
                        return {
                            label: item.name,
                            value: item.id,
                        };
                    }
                );
            }
        },
    },
    methods: {
        // Expuesto como metodo para poder pasarlo al ButtonExport desde la
        // plantilla, con el mismo adaptador que usa la tabla.
        adapterBalancerGroupsQuery,
        linkCount(item, key) {
            return Array.isArray(item[key]) ? item[key].length : 0;
        },
        openLinks(item, { key, kind }) {
            this.openModal({
                modalName: "links",
                data: { kind, items: item[key] },
            });
        },
        /**
         * Listado de destino filtrado por el id de la entrada o salida, el
         * mismo patron que ya usan los enlaces de `delivery_campaings.vue`.
         */
        /**
         * Ficha directa de la entrada o la salida, no el listado filtrado.
         * Se usan rutas con nombre para no depender del path, que en este repo
         * difiere entre ambas (`/app/campaigns/view` con el uuid en query,
         * `/app/delivery_campaings/:uuid/` con el uuid en el path).
         */
        linkRoute(entry) {
            if (this.modals.links.data.kind === "outputs") {
                return {
                    name: "update_delivery_campaign",
                    params: { uuid: entry.uuid },
                    query: { view_type: "edit" },
                };
            }
            return {
                name: "view_campaign",
                query: { view_type: "edit", uuid: entry.uuid },
            };
        },
        /**
         * Resumen agregado de todos los balanceadores en la ventana de fechas.
         * Endpoint propio, fuera de `client-groups`, con `from`/`to` directos
         * (no `stats_from`/`stats_to`, que son del listado).
         */
        async loadOverview() {
            this.overview.loading = true;
            this.overview.error = null;
            try {
                const response = await this.fetcher({
                    url: `/shipment.balancing.api/stats/overview`,
                    query: {
                        from: this.storeFrom,
                        to: this.storeTo,
                    },
                });
                this.overview.data = response || {};
            } catch (error) {
                // No se silencia: si el endpoint no responde la tira lo dice,
                // en vez de quedarse con guiones y parecer que no hay datos.
                this.overview.data = {};
                this.overview.error =
                    (error && error.response && error.response.status) ||
                    (error && error.message) ||
                    true;
            }
            this.overview.loading = false;
        },
        async updateData() {
            this.tables.groups.itemSelected = null;
            const overview = this.loadOverview();
            await this.updateTable({
                tableName: "groups",
                url: `/shipment.balancing.api/client-groups/pagination`,
                customFields: {
                    _selected: false,
                },
                // El selector de fechas acota la ventana de los *stats*, no que
                // balanceadores salen: el `created_at` se saca del `query` y la
                // ventana viaja en `stats_from`/`stats_to`.
                adapterFilters: adapterBalancerGroupsQuery,
                queryParams: this.statsWindow,
                // Aplana `stats` a numeros sueltos sobre cada item, que es de
                // donde leen las celdas. El orden lo hace el endpoint, no la
                // tabla.
                adapterData: adapterBalancerGroupsStats,
            });

            await overview;

            this.tables.groups.allFields = this.getTableAllFields("groups");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        /**
         * Nombre del tipo de balanceo para el tooltip del icono. El catalogo
         * llega por store, asi que puede no estar resuelto todavia: en ese caso
         * se cae a la etiqueta generica, nunca al uuid.
         */
        balancingLabel(item) {
            return (
                this.findBalancingShipmentTypeById(
                    item.shipment_balancing_type
                ) || this.$t("balancing")
            );
        },
        findBalancingShipmentTypeById(id) {
            let find = this.storeBalancingShipmentTypes.find((item) => {
                return item.id == id;
            });
            return find ? find.name : null;
        },
        /**
         * Los contadores llegan aplanados y casteados por
         * `adapterBalancerGroupsStats`, pero NO se puede dar por hecho que
         * sigan siendo numeros al pintarlos: `normalizeObject` del baseMixin
         * convierte todo `null` en cadena vacia antes de que los items lleguen
         * a la tabla. De ahi que estos dos validen el tipo en vez de confiar.
         */
        statNumber(value) {
            if (value === null || value === undefined || value === "") {
                return null;
            }
            const number = Number(value);
            return Number.isFinite(number) ? number : null;
        },
        statCount(value) {
            const number = this.statNumber(value);
            return number === null ? "-" : number;
        },
        statRate(value) {
            const number = this.statNumber(value);
            return number === null ? "-" : `${number.toFixed(1)}%`;
        },
        async archiveGroup(item) {
            let result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t(
                    "Are you sure you want to archive this group of clients?"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, archive it!"),
            });
            if (result.isConfirmed) {
                const response = await this.fetcher({
                    url: `/shipment.balancing.api/client-groups/${item.uuid}/archive`,
                    method: "PUT",
                });

                this.showMessageByMethod("PUT");
                await this.updateData();
            }
        },
    },
    mounted() {
        this.$store.dispatch("global/getBalancingShipmentTypes");
        this.updateData();
    },
};
</script>

<style scoped lang="scss">
// Solo para esta vista: el estado del balanceador como punto de color delante
// del nombre, en lugar de una columna propia.
.groups__status {
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    margin-right: 0.5rem;
    border-radius: 50%;
    cursor: help;

    &--on {
        background-color: #2eb85c;
    }

    &--off {
        background-color: #e55353;
    }
}

// Las tarjetas del resumen viven en `components/BalancerKpi.vue`; aqui solo
// queda el mensaje de error, que no es una tarjeta.
.overview__empty {
    font-size: 0.8rem;
    color: #768192;
}

// Iconos que sustituyen a las columnas `shipment_balancing_type` y
// `return_priority_response`.
.groups__flag {
    flex: 0 0 auto;
    margin-right: 0.4rem;
    cursor: help;

    &--balancing {
        color: #768192;
    }

    // Color de marca: se lee como "esta opcion esta puesta", no como aviso.
    &--priority {
        color: #117a8b;
    }

    // Reserva el hueco sin pintar el icono: asi los nombres quedan alineados
    // entre filas en vez de desplazarse segun tengan el flag o no.
    &--hidden {
        visibility: hidden;
    }
}
</style>
